import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from '../pages/Header';
import HomeLayout from '../pages/HomeLayout';
import Home from "../pages/Home";
import DodoDotStudio from "../pages/DodoDotStudio";
import Privacy from "../pages/Privacy";
import DeleteAccount from "../pages/DeleteAccount";
import KCookingTrip from "../pages/KCookinTrip";
import Redirect from "../pages/Redirect";

const Router = () => {
    return (
        <BrowserRouter>
            <Header />
            <Routes>
                <Route element={<HomeLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/studio" element={<DodoDotStudio />} />
                </Route>
                <Route path="/privacy-policy" element={<Privacy />} />
                <Route path="/deleteaccount" element={<DeleteAccount />} />
                <Route path="/kcookingsupport" element={<KCookingTrip />} />
                <Route path="/go" element={<Redirect />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Router;